module.exports = window['kestrel-core-ui'];